import React from "react";
import { Typography, Divider, Descriptions, List } from "antd";
import { UserOutlined } from "@ant-design/icons";
import days from "dayjs";
import PageHeader from "../../../headers/PageHeader";
import useAuth from "../../../../hooks/useAuth";
import { getUser } from "../../../../utils/getUser";
import { useUser } from "../../../../context/UserContext";

const { Title } = Typography;
const { Item } = Descriptions;

export default function Descripciongeneral({ item, users }) {
  const estadoFiltros = {
    InProgress: "Ejecutando",
    FalseAlarm: "Falsa alarma",
    Closed: "Cerrado",
    Open: "Abierto",
  };

  const user = useUser();
  const activitiesCompletas = item?.protocols[0]?.activities || [];

  const actividadCierre = activitiesCompletas.find((activity) =>
    activity.protocol_activity_subactivity.includes("cerrar-evento"),
  );

  const idUsuarioCierre =
    actividadCierre?.stateHistory?.Completed?.userId ||
    actividadCierre?.stateHistory?.Terminated?.userId;

  // const { session, UsuariosList } = useAuth();
  const FormatearMoneda = ({ valor }) => {
    const valorFormateado = new Intl.NumberFormat("es-CO", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(valor);

    return <span>{valorFormateado}</span>;
  };

  return (
    <div className="pdf-content">
      <div className="pdf-section">
        <PageHeader
          title={`Información General - ${item?.id || "cise-xxxx-xxx"}`}
          head={`Fecha de creación del informe: ${days().format(
            "MMM DD, YYYY hh:mm:ss A",
          )}`}
          createdBy={`Informe solicitado por: ${getUser(user.id, users)}`}
        />
      </div>

      <div className="pdf-section">
        <TextDivider item={item} />
        <Divider style={{ margin: "6px 0" }} />

        <Descriptions
          title={""}
          column={2}
          size="small"
          style={{ marginBottom: "12px" }}
          labelStyle={{ fontWeight: "bold", fontSize: "10px" }}
          contentStyle={{ fontSize: "10px" }}
        >
          <Item label="Estado">{estadoFiltros[item?.state] || "NA"}</Item>
          <Item label="Ubicación">{item?.location?.name || "NA"}</Item>
          <Item label="Lugar">{item?.location?.specific || "NA"}</Item>
          <Item label="Tipo">{item?.location?.type || "NA"}</Item>
          <Item label="Zona">{item?.location?.zone || "NA"}</Item>
          <Item label="Medio">{item?.location?.means || "NA"}</Item>
          <Item label="Fuente Información">{item?.source || "NA"}</Item>
          <Item label="Impacto">{item?.impact || "NA"}</Item>
          <Item label="Evento creado por:">
            {getUser(item.createdBy, users)}
          </Item>
          <Item label="Evento Cerrado por:">
            {getUser(idUsuarioCierre, users)}
          </Item>
        </Descriptions>
      </div>

      <div className="pdf-section">
        <Title level={5} className="pdf-subtitle">
          Informe
        </Title>
        <p className="pdf-text">
          {item?.title ||
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ac ligula sed risus ullamcorper volutpat. Sed sagittis orci egetjusto ultricies, vel facilisis tellus aliquet. Proin non est nec  purus facilisis consectetur non in metus. Nulla facilis Integer id lacus vel turpis fringilla consectetur. Vivamus"}
        </p>
      </div>

      <div className="pdf-section">
        <Divider style={{ margin: "6px 0" }} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            marginBottom: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "2px 0",
              fontSize: "10px",
            }}
          >
            <strong>Costo: </strong>
            <span>
              <FormatearMoneda valor={item.cost.total} />
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "2px 0",
              fontSize: "10px",
            }}
          >
            <strong>Descripción: </strong>
            <span style={{ maxWidth: "60%", textAlign: "right" }}>
              {item.cost.description}
            </span>
          </div>
        </div>
      </div>

      <div className="pdf-section">
        <Title level={5} className="pdf-subtitle">
          Causas Asociadas
        </Title>
        <div style={{ marginTop: "12px" }}>
          {item.causes.map((objeto, index) => (
            <div
              key={index}
              style={{
                marginBottom: "8px",
                padding: "6px",
                border: "1px solid #e8e8e8",
                borderRadius: "3px",
                backgroundColor: "#fafafa",
              }}
            >
              <Causas item={objeto} />
            </div>
          ))}
        </div>
      </div>

      <div className="pdf-section">
        <Divider style={{ margin: "6px 0" }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "2px 0",
            fontSize: "10px",
          }}
        >
          <strong>Costo de protocolo: </strong>
          <span>
            <FormatearMoneda valor={item.cost.total} />
          </span>
        </div>
      </div>
    </div>
  );
}

const TextDivider = ({ item }) => {
  const formatDate = (date) => {
    return date ? days(date).format("MMM DD, YYYY hh:mm:ss A") : "Sin fecha";
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "10px",
        marginBottom: "8px",
      }}
    >
      <div>
        <strong>Inicio: </strong>{" "}
        {formatDate(item?.stateHistory?.Open?.date) || ""}
      </div>
      <div>
        <strong>Cierre: </strong>{" "}
        {formatDate(
          item?.stateHistory?.Closed?.date ||
            item?.stateHistory?.FalseAlarm?.date,
        ) || "sin fecha"}
      </div>
    </div>
  );
};

const Causas = ({ item }) => {
  return (
    <div
      style={{
        fontSize: "10px",
      }}
    >
      {/* Título de la causa con icono */}
      <div
        style={{
          fontWeight: "bold",
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          fontSize: "11px",
          color: "#1890ff",
        }}
      >
        <UserOutlined style={{ color: "#1890ff" }} />
        Causa: {item.protocol_cause.split("_")[1].replace(/-/g, " ") || ""}
      </div>

      {/* Lista de implicados */}
      {item.participants && item.participants.length > 0 ? (
        <div style={{ marginLeft: "12px" }}>
          <div
            style={{
              fontWeight: "bold",
              marginBottom: "4px",
              fontSize: "9px",
              color: "#666",
            }}
          >
            Implicados ({item.participants.length}):
          </div>
          <List
            size="small"
            dataSource={item.participants}
            renderItem={(participantId, index) => (
              <List.Item
                style={{
                  padding: "2px 0",
                  border: "none",
                  fontSize: "9px",
                  marginBottom: "2px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#f5f5f5",
                    padding: "4px 6px",
                    borderRadius: "3px",
                    border: "1px solid #e8e8e8",
                  }}
                >
                  <span style={{ fontWeight: "bold", color: "#1890ff" }}>
                    ID: {participantId}
                  </span>
                  <span style={{ fontSize: "8px", color: "#999" }}>
                    Implicado #{index + 1}
                  </span>
                </div>
              </List.Item>
            )}
          />
        </div>
      ) : (
        <div
          style={{
            marginLeft: "12px",
            fontSize: "9px",
            color: "#999",
            fontStyle: "italic",
          }}
        >
          No hay implicados registrados
        </div>
      )}
    </div>
  );
};
